import React from 'react';
import BriefWizard from '@99designs/apps/spa/pages/create/briefs/BriefWizard';
import { StructuredBriefFragment } from '@99designs/apps/spa/pages/create/briefs/DynamicBrief/DynamicBrief.generated';
import { StepType } from '@99designs/apps/spa/pages/create/util/step';
import PaymentPage from '@99designs/apps/spa/pages/create/briefs/LogoDesign/PaymentPage';
import { createSteps } from './Step';

export function PurchaseBundleBriefWizard({
    brief,
    formData,
    refetch,
    currentStep,
}: {
    brief: StructuredBriefFragment;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    formData: Record<string, any>;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    refetch: (options: { id: string }) => Promise<any>;
    currentStep: number;
}) {
    return (
        <BriefWizard
            refetch={refetch}
            brief={{ ...brief, designers: [], contacts: [], projectIds: [] }}
            formData={formData}
            schema={brief.schemaId}
            currentStep={currentStep}
            steps={createSteps(brief, [
                {
                    title: __('Confirm details to start your logo + web bundle'),
                    isAuthRequired: true,
                    stepType: StepType.OrderPayment,
                    render: () => <PaymentPage brief={brief} />,
                    nextActionLabel: __('Pay now'),
                },
            ])}
        />
    );
}
